<template>
  <div ref="chart" class="chart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['dataShrink', 'dataRelax', 'label'],
  data() {
    return {}
  },
  mounted() {
    this.renderChart()
  },
  methods: {
    renderChart() {
      const chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', snap: true },
        },
        legend: {},
        xAxis: {
          type: 'category',
          data: this.label,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: [
          {
            name: 'mmHg',
            type: 'value',
            position: 'left',
            min: 50,
            max: 250,
          },
        ],
        series: [
          {
            name: '收縮壓',
            data: this.dataShrink,
            color: '#b74004',
            type: 'line',
            label: {
              show: true,
              position: 'top',
            },
          },
          {
            name: '舒張壓',
            data: this.dataRelax,
            color: '#047bb7',
            type: 'line',
            label: {
              show: true,
              position: 'top',
            },
          },
        ],
      }
      chart.setOption(option)
    },
  },
  watch: {
    label() {
      this.renderChart()
    },
    dataShrink() {
      this.renderChart()
    },
    dataRelax() {
      this.renderChart()
    },
  },
}
</script>
<style scoped>
.chart {
  width: 600px;
  height: 400px;
}

@media (max-width: 600px) {
  .chart {
    width: 100vw;
    height: 100vw;
  }
}
</style>
